<template>
    <st-filters-pagination
        stateModule="administrator/depList"
        :filters="filters"
        :total="total"
        @change="doFilter"
        :moreFilters="false"
        :header="$t('DEPARTMENTS.LIST.TITLE')"
        :showErase="false"
    >
        <template #filters-toolbar>
            <slot name="toolbar">
            </slot>
        </template>

        <slot></slot>
    </st-filters-pagination>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { FilterSchema } from '@/shared/form/filter-schema';
    import { DepartmentModel } from '@/modules/administrator/models/department-model';

    const { fields } = DepartmentModel;

    const filterSchema = new FilterSchema([
        fields.name,
        fields.status,
    ]);

    export default {
        name: 'DepartmentListFilter',
        props: {
            selectedInstitution: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters({
               total: 'administrator/depList/total',
            }),
            filters() {
                return filterSchema.fields;
            }
        },
        methods: {
            ...mapActions({
                doFetch: 'administrator/depList/getOrgDepartments',
            }),
            refresh() {
                this.doFilter(this.params);
            },
            doFilter(params) {
                this.params = params;
                this.doFetch({payload:params, id: this.selectedInstitution.id});
            },
        },

    };
</script>
